// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TextPayload__container-e69edf {
  max-width: var(--max-width-article-layout);
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  color: var(--base-110);
}

.TextPayload__text-b333be {
  cursor: text;
  font: var(--font-body-4);
  letter-spacing: var(--font-body-4);
  color: var(--base-110);
  white-space: pre-wrap;
  word-break: break-word;
}

.TextPayload__text-b333be[placeholder]:empty:before {
  font: var(--font-body-4);
  letter-spacing: var(--font-body-4);
  color: var(--base-70);
  content: attr(placeholder);
  pointer-events: none;
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChannelPopups/Article/ArticleRedactor/Payloads/TextPayload/TextPayload.styles.m.css"],"names":[],"mappings":"AAAA;EACE,0CAAA;EACA,wBAAA;EACA,0CAAA;EACA,sBAAA;AACF;;AAEA;EACE,YAAA;EACA,wBAAA;EACA,kCAAA;EACA,sBAAA;EACA,qBAAA;EACA,sBAAA;AACF;;AAEA;EACE,wBAAA;EACA,kCAAA;EACA,qBAAA;EACA,0BAAA;EACA,oBAAA;EACA,cAAA;AACF","sourcesContent":[".container {\n  max-width: var(--max-width-article-layout);\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  color: var(--base-110);\n}\n\n.text {\n  cursor: text;\n  font: var(--font-body-4);\n  letter-spacing: var(--font-body-4);\n  color: var(--base-110);\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.text[placeholder]:empty:before {\n  font: var(--font-body-4);\n  letter-spacing: var(--font-body-4);\n  color: var(--base-70);\n  content: attr(placeholder);\n  pointer-events: none;\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `TextPayload__container-e69edf`,
	"text": `TextPayload__text-b333be`
};
module.exports = ___CSS_LOADER_EXPORT___;
